import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import {
    SimpleForm,
    translate,
    crudDeleteMany
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { submit } from 'redux-form';
import SimpleButton from '@material-ui/core/Button';
import { startUndoable as startUndoableAction } from 'ra-core';

const styles = {
    button: { marginRight: '1em', marginLeft: '1em' },
};

class UserBulkDeleteButton extends Component {
    state = {
        showDialog: false
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    }

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleSaveClick = () => {
        const { submit } = this.props;
        submit('bulk-user-delete');
    };

    handleSubmit = () => {
        const { basePath, resource, selectedIds: ids, startUndoable } = this.props;
        startUndoable(
            crudDeleteMany(
                resource,
                ids,
                basePath
            )
        );
        this.setState({ showDialog: false });
    }

    render() {
        const { showDialog } = this.state;
        const { translate } = this.props;
        return (
            <Fragment>
                <SimpleButton 
                    variant="outlined" 
                    onClick={this.handleClick} 
                    style={styles.button} 
                    color="secondary">
                        {translate('resources.users.fields.bulkDelete')}
                </SimpleButton>
                <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={this.handleCloseClick}
                >
                    <DialogContent>
                        <DialogContentText>
                            <p>{translate('resources.users.fields.deleteGuidance')}</p>
                        </DialogContentText>
                    </DialogContent>
                    <DialogContent>
                        <SimpleForm toolbar={null} form='bulk-user-delete' onSubmit={this.handleSubmit} submitOnEnter={false}/>
                    </DialogContent>
                    <DialogActions>
                        <SimpleButton onClick={this.handleSaveClick} variant="raised" color='secondary'>{translate('ra.action.delete')}</SimpleButton>
                        <SimpleButton onClick={this.handleCloseClick} color='primary'>{translate('ra.action.cancel')}</SimpleButton>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

UserBulkDeleteButton.propTypes = {
    record: PropTypes.object,
    startUndoable: PropTypes.func,
};

const enhance = compose(
    translate,
    withStyles(styles),
    connect(
        undefined,
        { submit, startUndoable: startUndoableAction, crudDeleteMany }
    ),
);

export default enhance(UserBulkDeleteButton);